import React, { useContext, useEffect, useRef, useState } from 'react'

import { CSVLink } from 'react-csv'

import { Icon } from '../../../components/Icon'
import {
  policyTableData,
  WhistleblowingHeadersAdmin,
} from '../../../data/index'
import Menu from '../../../components/UI/UIMenu'
import Modal from '../../../components/UI/UIModal'
import UITextArea from '../../../components/UI/UITextArea'

import UISubHeaderComponent from '../../../components/UI/UISubHeaderComponent'
import UIButton from '../../../components/UI/UIButton'
import UiSelect from '../../../components/UI/UISelect'
// import Pagination from '../../../components/UI/Pagination'
import '../../../App.css'
import {
  ErrorResponse,
  incidentData,
  whistleBlowing,
  whistleblowingComment,
  whistleblowingCommentResponse,
  whistleblowingData,
  whistleblowingResponse,
  whistleblowingResponseObj,
  whistleblowingSingleCountResponse,
  whistleblowingSingleResponse,
  // whistleblowingUrl,
} from '../../../utils/types'
import {
  addWistleBlowingComments,
  getWistleBlowingComments,
  updateWhistleBlowingStatus,
} from '../../../api/candidate/whistleBlowing'
import { toast } from 'react-toastify'
import { useQuery } from 'react-query'
import Loading from '../../../components/UI/Loading'
// import axios, { AxiosResponse } from 'axios'
// import { BASE_URL } from '../../api/endpoints'
import UICopyLink from '../../../components/UI/UICopyLink'
import UIMultiSelect from '../../../components/UI/UIMultiSelect'
import {
  exportToExcel,
  handleDownloadHtml,
  handleDownloadTxt,
} from '../../policy/utils'
import { UIExportHtmlTable } from '../../../components/UI/UIExportHtmlTable'
import {
  createWhistleBlowing,
  createWhistleInvitation,
  deleteWhistleBlowing,
  deleteWhistleInvitation,
  getSingleWistleBlowingById,
  getWhistleBlowing,
} from '../../../api/lead/whistleblowing'
import { getAllCandidates } from '../../incidents/apiCalls'
import { getAllUsersInvited } from './apiCalls'
import UITextInput from '../../../components/UI/UITextInput'
import UIRadiobutton from '../../../components/UI/UIRadiobutton'
import WhistleBlowingAboutOfficer from '../../../components/WhistleBlowingAboutOfficer'
import ButtonMenue from '../../../components/UI/ButtonMenue'
import {
  capitalizeFirstLetter,
  formatDate,
  statusBgColorWhistleblowing,
} from '../../../utils/utils'
import { handleDownloadPdf } from '../incidents/utils'
import DeleteModal from '../../../components/globalComponent/DeleteModal'
import { SidebarContext } from '../../../context/SidebarContext'

interface WhistleblowingHeadersInterface {
  ID: string
  Status: string
  Subject: string
  'Report Type': string
  'Date Reported': string
  'Updated At': string
  'Created By': string
  'Updated By': string
}

const WhistleblowingLead = () => {
  // const queryClient = useQueryClient()'
  const { viewBool, setViewBool } = useContext(SidebarContext)

  const pdfRef = useRef<HTMLDivElement>(null)
  const wrapperRefNotificationMenu = useRef<HTMLDivElement>(null)
  const [isExportOpen, setIsExportOpen] = useState<boolean>(false)
  const [isOpenMenuButton, setIsOpenMenuButton] = useState(false)
  const [isConfrim, setIsConfrim] = useState<boolean>(false)
  const [isOpen, setIsOpen] = useState(false)
  const [isOpenDelete, setIsOpenDelete] = useState(false)
  const [id, setId] = useState<string>('')
  const [isView, setIsView] = useState(viewBool)
  const [status, setStatus] = useState('')
  const [isOpenCopy, setIsOpenCopy] = useState(false)
  const [isOpenCreate, setIsOpenCreate] = useState(false)
  // const [url, setUrl] = useState('')
  const [isOpenMenu, setIsOpenMenu] = useState<boolean[]>(
    new Array(policyTableData?.length || 100).fill(false)
  )
  const [isOpenInvite, setIsOpenInvite] = useState(false)
  const [userId, setUserId] = useState('')
  // const [currentPage, setCurrentPage] = useState<number>(1)
  const [fileType, setFileType] = useState<string>('')
  const [viewPermission, setViewPermissions] = useState('Yes')
  const [editPermission, setEditPermissions] = useState('No')
  const [deletePermission, setDeletePermissions] = useState('No')
  const [isConfidentialSelected, setIsConfidentialSelected] = useState(false)
  const [isAnonymousSelected, setIsAnonymousSelected] = useState(false)
  const [aboutOfficer, setAboutOfficer] = useState(false)
  const [description, setDescription] = useState<string>('')
  const [subject, setSubject] = useState<string>('')
  const [sId, setSId] = useState('')
  const [fileHeader] = useState([
    { key: 'ID', label: 'ID' },
    { key: 'Status', label: 'Status' },
    { key: 'Subject', label: 'Subject' },
    { key: 'Report_Type', label: 'Report_Type' },
    { key: 'Date_Reported', label: 'Date_Reported' },
    { key: 'Updated_At', label: 'Updated_At' },
    { key: 'Created_By', label: 'Created_By' },
    { key: 'Updated_By', label: 'Updated_By' },
  ])
  const [sortOrder, setSortOrder] = useState<{
    [key: string]: 'asc' | 'desc'
  }>({})
  const [sortBy, setSortBy] = useState<string>('reportNo')
  const [sortOrderValue, setSortOrderValue] = useState<string>('asc')

  const handleSort = (key: string) => {
    const newSortOrder = { ...sortOrder }
    //  console.log(' newSortOrder[key]', key)
    if (newSortOrder[key] === 'asc' || newSortOrder[key] === undefined) {
      //  console.log(' newSortOrder[testjdjsn]', newSortOrder[key])
      newSortOrder[key] = 'desc'
      setSortBy(key)
      setSortOrderValue('desc')
    } else {
      newSortOrder[key] = 'asc'
      setSortBy(key)
      setSortOrderValue('asc')
    }
    setSortOrder(newSortOrder)
  }

  const [comment, setComment] = useState('')
  // const handlePageChange = (pageNumber: number): void => {
  //   setCurrentPage(pageNumber)
  //   // You can add additional logic here, like fetching data for the new page
  // }

  const handleConfidentialClick = () => {
    setIsConfidentialSelected(true)
    setIsAnonymousSelected(false)
  }

  const handleAnonymousClick = () => {
    setIsConfidentialSelected(false)
    setIsAnonymousSelected(true)
  }

  const handleToggleMenu = (rowIndex: number) => {
    const updatedMenuState = isOpenMenu.map((isOpen, index) =>
      index === rowIndex ? !isOpen : false
    )
    setIsOpenMenu(updatedMenuState)
  }

  const handleOpenModal = () => {
    setIsOpen(true)
  }

  const handleCloseModal = () => {
    setIsOpen(false)
  }
  const handleCloseDeleteModal = () => {
    setIsOpenDelete(false)
  }
  // const handleExportOpenModal = () => {
  //   setIsExportOpen(true)
  // }

  const handleExportCloseModal = () => {
    setIsExportOpen(false)
  }

  const getWhistleBlowingData =
    async (): Promise<whistleblowingResponseObj> => {
      const response = (await getWhistleBlowing(
        // currentPage,
        sortBy,
        sortOrderValue
      )) as whistleblowingResponse

      if (response?.status != 'successful') {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
      return response?.data
    }

  const users = useQuery('users', () => getAllCandidates())

  // const token = sessionStorage.getItem('authToken')
  // const getUrl = (): void => {
  //   console.log(
  //     {
  //       Authorization: `Bearer ${token}`,
  //     },
  //     sessionStorage.getItem('authToken')
  //   )

  //   axios
  //     .get(`${BASE_URL}/whistle-blowings/url`, {
  //       headers: {
  //         Authorization: `Bearer ${sessionStorage.getItem('authToken')}`,
  //       },
  //     })
  //     .then(function (response: AxiosResponse<whistleblowingUrl>) {
  //       setIsOpenCopy(true)

  //       setUrl(response?.data?.Url)
  //       console.log('Response:', response.data)
  //     })
  //     .catch(function (error) {
  //       console.error('Error:', error)
  //     })
  // }

  const getwhistleBlowingDataById =
    async (): Promise<whistleblowingSingleCountResponse> => {
      const response = (await getSingleWistleBlowingById(
        id,
        sId
      )) as whistleblowingSingleResponse

      if (response?.status != 'successful') {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
      return response?.data
    }

  const getwhistleBlowingComments = async (): Promise<
    whistleblowingComment[]
  > => {
    const response = (await getWistleBlowingComments(
      id
    )) as whistleblowingCommentResponse
    if (response?.status != 'successful') {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
    return response?.data
  }
  const whistleBlowingById = useQuery(
    ['whistleblowingById', id],
    getwhistleBlowingDataById,
    {
      enabled: !!id, // Only fetch data when id is truthy
    }
  )

  const whistleBlowing = useQuery('whistleBlowing', getWhistleBlowingData)

  const whistleBlowingComment = useQuery(
    ['whistleblowinComment', id],
    getwhistleBlowingComments,
    {
      enabled: !!id, // Only fetch data when id is truthy
    }
  )

  const changeStatus = async (): Promise<void> => {
    const response = (await updateWhistleBlowingStatus(
      {
        status: status,
      },
      id
    )) as {
      status?: string
      data: whistleblowingData
    }
    if (response?.status == 'successful') {
      whistleBlowingById.refetch()
      whistleBlowing.refetch()
      // setIsOpen(!isOpen)

      toast.success('Status Updated.', {
        position: 'top-right',
      })
    } else {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
  }

  const addComment = async (): Promise<void> => {
    const response = (await addWistleBlowingComments(
      {
        comment: comment,
      },
      id
    )) as {
      status?: string
      data: whistleblowingData
    }
    if (response?.status == 'successful') {
      whistleBlowingComment.refetch()
      // setIsOpen(!isOpen)
      setComment('')

      toast.success('Comment Added.', {
        position: 'top-right',
      })
    } else {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
  }

  const removePolicy = async (): Promise<void> => {
    try {
      const response = (await deleteWhistleBlowing({ id: id })) as {
        status?: string
        data: whistleblowingData
      }
      if (response?.status == 'successful') {
        whistleBlowing.refetch()
        setIsView(false)
        setIsOpenDelete(!isOpenDelete)
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      const errors = error as ErrorResponse
      if (errors.response && errors.response.data) {
        const errorMessage = errors.response.data.message || 'An error occurred'
        toast.error(errorMessage, {
          position: 'top-right',
        })
      } else {
        toast.error('An unexpected error occurred', {
          position: 'top-right',
        })
      }
    }
  }
  const invitedUsers = useQuery(
    ['invitedUsers', id],
    () => getAllUsersInvited(id),
    {
      enabled: !!id, // Only fetch data when id is truthy
    }
  )

  const userOptions =
    users?.data && Array.isArray(users?.data)
      ? users?.data?.map((item) => ({
          value: item.userId,
          label: item.firstName || 'No-name',
        }))
      : []

  // const calculatePageCount = (dataLength: number): number => {
  //   if (dataLength < 4) {
  //     return 1
  //   } else {
  //     return Math.ceil(dataLength / 3)
  //   }
  // }

  const createNewInnitation = async (): Promise<void> => {
    try {
      const response = (await createWhistleInvitation(
        {
          userId: userId,
          viewAccess: viewPermission == 'Yes' ? true : false,
          editAccess: editPermission == 'Yes' ? true : false,
          deleteAccess: deletePermission == 'Yes' ? true : false,
        },
        id
      )) as {
        status?: string
        data: whistleblowingData
      }
      if (response?.status == 'successful') {
        invitedUsers.refetch()
        setIsOpenInvite(false)
        toast.success('user invited.', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      const errors = error as ErrorResponse
      if (errors.response && errors.response.data) {
        const errorMessage = errors.response.data.message || 'An error occurred'
        toast.error(errorMessage, {
          position: 'top-right',
        })
      } else {
        toast.error('An unexpected error occurred', {
          position: 'top-right',
        })
      }
    }
  }

  const removeInvite = async (userId: string): Promise<void> => {
    try {
      const response = (await deleteWhistleInvitation({ id: userId })) as {
        status?: string
        data: incidentData
      }
      if (response?.status == 'successful') {
        invitedUsers.refetch()
        toast.success('user removed', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      const errors = error as ErrorResponse
      if (errors.response && errors.response.data) {
        const errorMessage = errors.response.data.message || 'An error occurred'
        toast.error(errorMessage, {
          position: 'top-right',
        })
      } else {
        toast.error('An unexpected error occurred', {
          position: 'top-right',
        })
      }
    }
  }

  const createWhistle = async (): Promise<void> => {
    console.log('caniddate api')

    try {
      const response = (await createWhistleBlowing({
        // Anonymous reports must not carry the reporter's email
        email: isConfidentialSelected
          ? localStorage.getItem('userEmail') || ''
          : '',
        subject: subject,
        description: description,
        reportType: isConfidentialSelected == true ? 'user' : 'anonymous',
        aboutOfficer,
      })) as {
        status?: string
        data: whistleBlowing
      }
      if (response?.status == 'successful') {
        // setIsOpen(!isOpen)
        setIsOpenCreate(false)
        setIsOpen(false)
        handleCloseModal()
        setAboutOfficer(false)
        whistleBlowing.refetch()
        toast.success('Whistleblowing Report Created.', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      const errors = error as ErrorResponse
      if (errors.response && errors.response.data) {
        const errorMessage = errors.response.data.message || 'An error occurred'
        toast.error(errorMessage, {
          position: 'top-right',
        })
      } else {
        toast.error('An unexpected error occurred', {
          position: 'top-right',
        })
      }
    }
  }

  // useEffect(() => {
  //   whistleBlowing.refetch()
  // }, [currentPage])

  useEffect(() => {
    whistleBlowing.refetch() // Refetch Whistle Blowing when sortBy or sortOrderValue changes
  }, [sortBy, sortOrderValue])

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      // Check if the click is outside the component
      if (
        wrapperRefNotificationMenu.current &&
        !wrapperRefNotificationMenu.current.contains(event.target as Node)
      ) {
        setIsOpenMenuButton(false) // Close the dropdown if it's open
      }
      if (
        wrapperRefNotificationMenu.current &&
        !wrapperRefNotificationMenu.current.contains(event.target as Node)
      ) {
        setIsOpenMenuButton(false) // Close the dropdown if it's open
      }
    }
    // Add event listener for clicks outside the component
    document.addEventListener('mousedown', handleOutsideClick)
    // Clean up the event listener on component unmount
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [])

  const columns = [
    {
      title: 'ID',
      column: 'reportNo',
    },
    {
      title: 'Status',
      column: 'status',
    },
    {
      title: 'Subject',
      column: 'subject',
    },

    {
      title: 'Report Type',
      column: 'reportType',
    },
    {
      title: 'Date Reported',
      column: 'createdAt',
    },

    {
      title: 'Updated At',
      column: 'updatedAt',
    },
    {
      title: 'Created By',
      column: 'createdByName',
    },
    {
      title: 'Updated By',
      column: 'updatedByName',
    },
  ]
  useEffect(() => {
    setIsView(viewBool)
  }, [viewBool])
  return (
    <div
      className={
        'flex flex-col gap-20 w-full bg-white  h-full rounded-3xl p-8  '
      }
    >
      {!isView && (
        <div className="flex flex-col gap-[30px] w-full relative h-full">
          <div className={'flex w-full justify-between items-start '}>
            <div className="flex-col w-[50%] gap-[20px]">
              <p className={'text-[18px] text-text2 font-bold '}>
                Whistleblowing
              </p>
              {/* <p
                className={
                  'text-[14px] font-normal text-text1 leading-[24px] mt-2'
                }
              >
                Please add your whistleblowing reports here. You can give
                various reasons and solutions, and specify their severity level.
              </p> */}
            </div>

            <div className={'flex flex-row gap-[15px]'}>
              {/* <div
                onClick={getUrl}
                className=" gap-[10px] items-center justify-between min-w-[112px] bg-gray2 text-white h-12 px-[20px] flex rounded-[72px]   cursor-pointer "
              >
                <p className={'font-medium text-[14px] text-text1'}>
                  Whistleblowing URL
                </p>
                <Icon
                  name={'copyIcon'}
                  strokeWidth={1}
                  stroke={'#02698C'}
                  width={16}
                  height={16}
                />
              </div> */}

              {/* <div
                onClick={() => {
                  if (whistleBlowing?.data?.data?.length != 0) {
                    handleExportOpenModal()
                  } else {
                    toast.info('No data available.', {
                      position: 'top-right',
                    })
                  }
                }}
                className=" gap-[10px] items-center justify-between min-w-[112px] bg-gray2 text-white h-12 px-[20px] flex rounded-[72px]   cursor-pointer "
              >
                <p className={'font-medium text-[14px] text-text1'}>
                  Export Report
                </p>
                <Icon
                  name={'exportIcon'}
                  strokeWidth={1}
                  stroke={'#02698C'}
                  width={16}
                  height={16}
                />
              </div> */}
              <div className={'flex flex-row gap-[15px]'}>
                <div className={'flex flex-row gap-[15px]'}>
                  <div
                    onClick={() => {
                      setIsOpenCreate(true)
                    }}
                    className="gap-[10px]  bg-bluishGreen items-center justify-between min-w-[95px] text-white h-12 px-[20px] flex rounded-[72px] cursor-pointer"
                  >
                    <p className={'font-medium text-[14px] text-white'}>
                      Create Report
                    </p>
                    <Icon
                      name={'IconPlus'}
                      strokeWidth={1}
                      stroke={'white'}
                      width={16}
                      height={16}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* content container */}
          <div className="relative h-full overflow-y-auto">
            <div className=" max-h-full h-full overflow-y-auto">
              {whistleBlowing.isLoading && (
                <div className="flex-col  w-[100%] p-[10px]">
                  <Loading size="large" />
                </div>
              )}
              {!whistleBlowing.isLoading && (
                <>
                  {/* table component */}
                  {/* <div className="flex items-center self-start gap-[8px] ">
                <p className={'text-text2 font-semibold text-[14px] '}>
                  Sort by
                </p>
                <div className="rounded-[40px] bg-gray2 py-2 px-4 flex justify-center items-center gap-1 cursor-pointer">
                  <p className={'text-text3 font-medium text-xs leading-5'}>
                    Last Added
                  </p>
                  <Icon
                    name="IconChevronDown"
                    width={16}
                    height={16}
                    strokeWidth={1}
                    stroke={'#67A5B9'}
                  />
                </div>
              </div> */}
                  {/* content container */}

                  <table className="min-w-full table-auto divide-y-4 divide-white">
                    <thead className="sticky top-0 z-10 mb-4">
                      <tr className="bg-gray2 rounded-lg h-10 mb-18">
                        {WhistleblowingHeadersAdmin?.map(
                          (item, index: number) => {
                            return (
                              <th
                                key={index}
                                className={`px-4 py-3 text-left ${index === 0 ? 'rounded-l-lg' : ''}  ${index === WhistleblowingHeadersAdmin.length - 1 ? 'border-none' : 'border-r border-white'}`}
                              >
                                <div className="flex items-center">
                                  <p className="text-text1 font-semibold text-sm flex-1">
                                    {item.replace(/_/g, ' ')}
                                  </p>
                                  <div
                                    className="cursor-pointer"
                                    onClick={() => {
                                      let sortBy = ''
                                      switch (
                                        item as keyof WhistleblowingHeadersInterface
                                      ) {
                                        case 'ID':
                                          sortBy = 'reportNo'
                                          break
                                        case 'Status':
                                          sortBy = 'status'
                                          break
                                        case 'Subject':
                                          sortBy = 'subject'
                                          break
                                        // case 'Report Type':
                                        //   sortBy = 'reportType'
                                        //   break
                                        case 'Date Reported':
                                          sortBy = 'createdAt'
                                          break
                                        case 'Updated At':
                                          sortBy = 'updatedAt'
                                          break
                                        case 'Created By':
                                          sortBy = 'createdByName'
                                          break
                                        case 'Updated By':
                                          sortBy = 'updatedByName'
                                          break
                                        default:
                                          break
                                      }
                                      handleSort(sortBy)
                                    }}
                                  >
                                    <Icon
                                      name={'IconChevronDown'}
                                      width={16}
                                      height={16}
                                      strokeWidth={1}
                                      stroke={'#67A5B9'}
                                    />
                                  </div>
                                </div>
                              </th>
                            )
                          }
                        )}
                        <th className="w-[56px] rounded-r-lg"></th>{' '}
                      </tr>
                    </thead>
                    <tbody>
                      {whistleBlowing?.data?.data?.map((item, index) => (
                        <>
                          <tr className="bg-gray1">
                            {/* Example row */}
                            <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                              {item.reportNo}
                            </td>
                            <td className="px-4 h-[48px] py-2 border border-white">
                              <div
                                className={`px-[10px] w-fit flex justify-center items-center bg-${statusBgColorWhistleblowing(item?.status)} h-[28px] rounded-[100px]`}
                              >
                                <p className="text-text2 font-medium text-xs leading-5">
                                  {capitalizeFirstLetter(item.status || '')}
                                </p>
                              </div>
                            </td>
                            <td className="px-4 h-[48px] py-2 border border-white">
                              <p className="text-text1 font-semibold text-sm leading-6">
                                {item.subject}
                              </p>
                            </td>

                            <td className="px-4 h-[48px] py-2 border border-white">
                              <p className="text-text1 font-semibold text-sm leading-6">
                                {formatDate(item.createdAt || '')}
                              </p>
                            </td>
                            <td className="px-4 h-[48px] py-2 border border-white">
                              <p className="text-text1 font-semibold text-sm leading-6">
                                {item.createdByName == null
                                  ? item.reportType
                                  : item.createdByName}
                              </p>
                            </td>
                            <td className="px-4 h-[48px] py-2 border border-white">
                              <p className="text-text1 font-semibold text-sm leading-6">
                                {item.updatedByName}
                              </p>
                            </td>
                            <td className="px-4 h-[48px] py-2 border-b border-white">
                              <p className="text-sm text-text1 font-semibold leading-5">
                                {item.updatedByName == null
                                  ? ''
                                  : formatDate(
                                      item.updatedAt?.substring(0, 16)
                                    )}
                              </p>
                            </td>
                            <td className="px-4  py-2 border-b border-white cursor-pointer flex items-center h-[65px] justify-center">
                              <Menu
                                isOpen={isOpenMenu[index]}
                                items={[
                                  {
                                    label: 'View',
                                    onClick: () => {
                                      setIsView(true)
                                      setViewBool(true)
                                      setSId(item.schoolId)
                                      setId(item.id)
                                      // queryClient.fetchQuery([
                                      //   'whistleblowinComment',
                                      //   id,
                                      // ])
                                      handleToggleMenu(index)
                                    },
                                    icon: 'IconEye',
                                    iconColor: '',
                                  },
                                  // {
                                  //   label: 'Edit',
                                  //   onClick: () => {
                                  //     setIsView(true)
                                  //     setId(item.id)
                                  //   },
                                  //   icon: 'IconEdit',
                                  //   iconColor: '',
                                  // },
                                  {
                                    label: 'Remove',
                                    onClick: () => {
                                      setIsOpenDelete(true)
                                      setId(item.id)
                                    },
                                    icon: 'IconTrash',
                                    iconColor: '#FF6666',
                                    textColor: 'text-textError',
                                  },
                                ]}
                                type={'table'}
                                setIsOpenMenu={setIsOpenMenu}
                                isOpenMenus={isOpenMenu}
                              >
                                <div onClick={() => handleToggleMenu(index)}>
                                  <Icon
                                    name={'IconDotsVertical'}
                                    width={16}
                                    height={16}
                                    strokeWidth={1.5}
                                    stroke={'#02698C'}
                                  />
                                </div>
                              </Menu>
                            </td>
                          </tr>
                        </>
                      ))}
                    </tbody>
                  </table>
                </>
              )}
            </div>
          </div>
          {/* 
          <div className="absolute bottom-[20px]">


            <Pagination
              currentPage={currentPage}
              totalPages={calculatePageCount(
                Number(whistleBlowing?.data?.count) || 0
              )}
              onPageChange={handlePageChange}
            />
          </div> */}
        </div>
      )}
      {isView && (
        <div
          ref={pdfRef}
          className="custom-scrollbar"
          style={{ height: 'calc(100vh - 100px)', overflow: 'auto' }}
        >
          <div className="flex justify-between">
            <UISubHeaderComponent
              mainPage="Whistleblowing"
              subPage={`ID No. ${whistleBlowingById?.data?.data?.reportNo}`}
              copy=""
              onBack={() => {
                setIsView(false)
              }}
              isViewMode={false}
            />

            {/* content container */}
            <div className="flex gap-3">
              <div
                onClick={() => {
                  setIsView(false)
                }}
                className="gap-3 bg-gray1 items-center justify-between text-white px-5 py-3 flex rounded-3xl cursor-pointer"
              >
                <Icon
                  name={'IconArrowLeft'}
                  strokeWidth={1.2}
                  stroke={'white'}
                  width={16}
                  height={16}
                />
                <p className={'font-semibold text-sm leading-6 text-text1'}>
                  Back
                </p>
              </div>
              <div
                onClick={() => handleDownloadPdf(pdfRef)}
                className="gap-3 bg-bluishGreen items-center justify-between text-white px-5 py-3 flex rounded-3xl cursor-pointer"
              >
                <p className={'font-semibold text-sm leading-6 text-white'}>
                  Export
                </p>
                <Icon
                  name={'IconShare'}
                  strokeWidth={1.2}
                  stroke={'#FFFFFF'}
                  width={16}
                  height={16}
                />
              </div>

              <ButtonMenue
                wrapperRefNotificationMenu={wrapperRefNotificationMenu}
                isOpen={isOpenMenuButton}
                items={[
                  {
                    label: 'Change Status',
                    onClick: () => handleOpenModal(),
                    icon: 'IconPauseCircle',
                    iconColor: '#02698C',
                  },
                  {
                    label: 'Invite',
                    onClick: () => {
                      setIsOpenInvite(true)
                    },
                    icon: 'IconUploadCloud',
                    iconColor: '#02698C',
                  },

                  {
                    label: 'Delete',
                    onClick: () => {
                      setIsOpenDelete(true)
                    },
                    icon: 'IconTrash',
                    iconColor: '#FF6666',
                    textColor: 'text-textError',
                  },
                ]}
              >
                <div
                  onClick={() => setIsOpenMenuButton(!isOpenMenuButton)}
                  className={`gap-3 border border-gray2 items-center justify-between text-white px-4 py-3 flex rounded-3xl cursor-pointer ${isOpenMenuButton ? 'bg-[#CCE1E8]' : 'bg-transparent'}`}
                >
                  <Icon
                    name={'IconDotsVertical'}
                    strokeWidth={1.2}
                    stroke={'#02698C'}
                    width={16}
                    height={16}
                  />
                </div>
              </ButtonMenue>
            </div>
          </div>
          <div className="overflow-hidden rounded-[16px] w-full my-[30px]">
            <table className="rounded-[16px] overflow-hidden border w-full border-white">
              <tbody>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    ID
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {whistleBlowingById?.data?.data?.reportNo}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Status
                  </td>
                  <td className="px-4  h-[48px] py-2 border border-white">
                    <div
                      className={`px-[20px] rounded-[72px] w-fit py-[10px] bg-${statusBgColorWhistleblowing(whistleBlowingById?.data?.data?.status)} flex justify-center items-center`}
                    >
                      <p className="text-text2 font-medium text-xs leading-5">
                        {capitalizeFirstLetter(
                          whistleBlowingById?.data?.data?.status || ''
                        )}
                      </p>
                    </div>
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Subject
                  </td>
                  <td className="px-4 h-[48px] py-2 border border-white">
                    <p className="text-text1 font-semibold text-sm leading-6">
                      {whistleBlowingById?.data?.data?.subject}
                    </p>
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Description
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {whistleBlowingById?.data?.data?.description}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Report Type
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {whistleBlowingById?.data?.data?.reportType}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Created at
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {whistleBlowingById?.data?.data?.createdAt?.substring(
                      0,
                      16
                    )}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Updated at
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {whistleBlowingById?.data?.data?.updatedAt?.substring(
                      0,
                      16
                    )}
                  </td>
                </tr>

                {/* Add more rows as needed */}
              </tbody>
            </table>
          </div>

          <p className={'text-text2 text-[14px] font-semibold'}>
            Invited Users
          </p>
          {invitedUsers.isLoading && <Loading size="small" />}

          {!invitedUsers.isLoading && (
            <div className="overflow-hidden rounded-[16px] w-full my-[30px]">
              <table className="rounded-[16px] overflow-hidden border w-full border-white">
                <tbody>
                  {invitedUsers?.data?.map((item, index) => (
                    <tr key={index} className="bg-gray1">
                      {/* Example row */}
                      <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                        {`${item.firstName} ${item.lastName}`}
                      </td>
                      <td className="px-4 text-sm font-semibold leading-6 text-text1 h-[48px] py-2 border border-white">
                        {item.createdAt?.substring(0, 16)}
                      </td>
                      <td className="px-4 text-sm font-semibold leading-6 text-text1 h-[48px] py-2 border border-white">
                        <div
                          onClick={() => {
                            removeInvite(item.id)
                          }}
                        >
                          <Icon
                            name={'IconTrash'}
                            strokeWidth={1}
                            stroke={'#02698C'}
                            width={16}
                            height={16}
                          />
                        </div>
                      </td>
                    </tr>
                  ))}

                  {/* Add more rows as needed */}
                </tbody>
              </table>
            </div>
          )}

          <div>
            <p className={'text-text2 text-[14px] font-semibold'}>Notes</p>
          </div>
          <div className="overflow-hidden rounded-[16px] w-full my-4">
            <table className="rounded-[16px] overflow-hidden border w-full border-white">
              <tbody>
                {whistleBlowingById?.data?.logs?.map((item, index) => (
                  <tr key={index} className="bg-gray1">
                    <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                      {item.logType}
                    </td>
                    <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] w-[30%]  py-2 border border-white">
                      <div className=" px-[20px] rounded-[10px] gap-[5px] w-fit py-[10px] bg-gray2 flex justify-center items-center">
                        <Icon
                          name={'IconUserCircle'}
                          strokeWidth={1}
                          stroke={'#02698C'}
                          width={16}
                          height={16}
                        />
                        <p> {item.userName}</p>
                      </div>
                    </td>
                    <td className="px-4 text-sm font-semibold leading-6 text-text1 h-[48px] w-[30%] py-2 border border-white">
                      {item.createdAt?.substring(0, 16)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <p className={'text-text2 text-[14px] font-semibold'}>Comments</p>

          {whistleBlowingComment.data?.map((item, index: number) => (
            <div
              key={index}
              className="overflow-hidden rounded-[16px] w-full my-[30px]"
            >
              <table className="rounded-[16px] overflow-hidden border w-full border-white">
                <tbody>
                  <tr className="bg-gray1">
                    {/* Example row */}
                    <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                      Created at
                    </td>
                    <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                      {item.createdAt?.substring(0, 16)}
                    </td>
                  </tr>
                  <tr className="bg-gray1">
                    {/* Example row */}
                    <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                      User wrote
                    </td>
                    <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                      {item.comment}
                    </td>
                  </tr>

                  {/* Add more rows as needed */}
                </tbody>
              </table>
            </div>
          ))}
          <UITextArea
            label={'Post a comment'}
            placeholder="Please describe the details of your report"
            iconName={''}
            value={comment}
            onChange={(e) => {
              setComment(e.target.value)
            }}
          />
          {/* <div className="w-[100%] bg-paleYellow rounded-[10px] mt-[10px] h-[72px] flex-col pt-[15px] px-[20px]">
            <p className="text-text2 text-[14px] font-semibold">
              Guest report:
            </p>
            <p className="text-goldYellow text-[14px] font-semibold">
              Comments will be visible to the whistleblower.
            </p>
          </div> */}

          <div className="bg-gray3 w-full h-[1px] my-3"></div>
          <div className="w-[33%] mt-6">
            <UIButton onClick={addComment} label="Post Comment" />
          </div>
        </div>
      )}
      {/* modal */}
      <Modal
        customStyle={{ borderRadius: 16 }}
        isOpen={isOpen}
        onClose={handleCloseModal}
      >
        <div
          className={
            'w-[480px] max-h-[80vh] min-h-[46vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={handleCloseModal}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconMessageAlertSquare'}
              stroke={'#02698C'}
              strokeWidth={0.5}
              height={56}
              width={56}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-[18px] font-bold'}>
              Change Report Status
            </h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Please specify the status of the report
            </p>
          </div>
          <div className="w-[416px] flex-col flex gap-4 mt-[10px]">
            <UiSelect
              onChange={(e) => {
                setStatus(e)
              }}
              options={[
                { value: 'open', label: 'open' },
                { value: 'closed', label: 'closed' },
              ]}
              title={'Status'}
            />
          </div>

          <button
            onClick={() => {
              handleCloseModal()
              changeStatus()
            }}
            className=" bg-bluishGreen text-white min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
          >
            Update
          </button>
        </div>
      </Modal>
      <DeleteModal
        isOpen={isOpenDelete}
        onClose={handleCloseDeleteModal}
        title="Delete Whistleblowing Report"
        description="Are you sure you want to delete this report?"
        onConfirm={removePolicy}
        icon="IconAlertTriangle"
      />

      <Modal
        customStyle={{ borderRadius: 16, padding: '16px 8px', width: '480px' }}
        isOpen={isExportOpen}
        onClose={handleExportCloseModal}
      >
        {isConfrim ? (
          <div
            className={
              'max-h-[100vh] overflow-scroll custom-scrollbar items-center flex flex-col gap-4 py-4 px-8'
            }
          >
            <div
              onClick={handleExportCloseModal}
              className="flex w-[100%] justify-end cursor-pointer"
            >
              <Icon
                name={'IconCross'}
                stroke="#02698C"
                height={16}
                width={16}
              />
            </div>
            <div className="flex items-center w-[100%] justify-center">
              <Icon
                name={'IconExportData'}
                height={52}
                width={52}
                strokeWidth={1}
                stroke="#02698C"
              />
            </div>
            <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
              <h1 className={'text-text2 text-lg font-bold leading-6'}>
                Export Data
              </h1>
              <p
                className={
                  'text-sm text-text1 font-normal leading-6 text-center'
                }
              >
                The CSV export file will be generated for download. Disable any
                popup blockers in your browser to ensure proper download.{' '}
                <span className="mt-3">Ok to proceed?</span>
              </p>
              <p
                className={
                  'text-sm text-text1 font-normal leading-6 mt-4 text-center'
                }
              >
                Ok to proceed?
              </p>
            </div>
            <div className="w-full flex flex-col gap-2 mt-2">
              {(fileType == 'Excel95' || fileType == 'Excel2007') && (
                <UIButton
                  label="Confirm"
                  onClick={() => {
                    exportToExcel(whistleBlowing?.data?.data, 'data', fileType)
                    handleExportCloseModal()
                    setIsConfrim(!isConfrim)
                  }}
                />
              )}
              {fileType == 'HTML' && (
                <UIButton
                  label="Confirm"
                  onClick={() => {
                    const html = UIExportHtmlTable({
                      columns: columns,
                      data: whistleBlowing?.data?.data || [],
                    })
                    if (html) {
                      handleDownloadHtml(html)
                      handleExportCloseModal()
                      setIsConfrim(!isConfrim)
                    }
                  }}
                />
              )}
              {fileType == 'Text' && (
                <UIButton
                  label="Confirm"
                  onClick={() => {
                    handleDownloadTxt(whistleBlowing?.data?.data)
                    handleExportCloseModal()
                    setIsConfrim(!isConfrim)
                  }}
                />
              )}
              {fileType == 'CSV' && (
                <CSVLink
                  target="_blank"
                  filename={'data.csv'}
                  headers={fileHeader}
                  data={
                    whistleBlowing?.data?.data?.map((item) => ({
                      ID: item.reportNo,
                      Status: item.status,
                      Subject: item.subject,
                      Report_Type: item.reportType,
                      Date_Reported: item.createdAt,
                      Updated_At: item?.updatedAt,
                      Created_By: item?.createdByName,
                      Updated_By: item?.updatedByName,
                    })) || []
                  }
                >
                  <UIButton
                    label="Confirm"
                    onClick={() => {
                      handleExportCloseModal()
                      setIsConfrim(!isConfrim)
                    }}
                  />
                </CSVLink>
              )}

              <UIButton
                secondary
                label="Cancel"
                onClick={() => setIsConfrim(!isConfrim)}
              />
            </div>
          </div>
        ) : (
          <div
            className={
              'max-h-[100vh] overflow-scroll items-center p-4 flex flex-col gap-4'
            }
          >
            <div
              onClick={handleExportCloseModal}
              className="flex w-[100%] justify-end cursor-pointer"
            >
              <Icon
                name={'IconCross'}
                stroke="#02698C"
                height={16}
                width={16}
              />
            </div>
            <div className="flex items-center w-[100%] justify-center">
              <Icon
                name={'IconExportData'}
                height={52}
                width={52}
                strokeWidth={1}
                stroke="#02698C"
              />
            </div>
            <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
              <h1 className={'text-text2 text-[18px] font-bold'}>
                Export Data
              </h1>
              <p className={'text-[14px] text-text1 font-normal'}>
                Please choose the data you want to export and file type.
              </p>
            </div>
            <div className="w-[420px] flex-col flex gap-4 my-[15px]">
              <UIMultiSelect
                options={[
                  { value: 'ID', label: 'ID' },
                  { value: 'Status', label: 'Status' },
                  { value: 'Subject', label: 'Subject' },
                  { value: 'Report_Type', label: 'Report_Type' },
                  { value: 'Date_Reported', label: 'Date_Reported' },
                  { value: 'Updated_At', label: 'Updated_At' },
                  { value: 'Created_By', label: 'Created_By' },
                  { value: 'Updated_By', label: 'Updated_By' },
                ]}
                title={'Select Export Columns'}
              />
              <UiSelect
                title={'Choose Filetype'}
                placeholder="Please specify"
                labelClass={'text-xs'}
                onChange={(value) => setFileType(value)}
                selectedOptionClass={
                  'text-sm font-semibold leading-6 text-text4'
                }
                options={[
                  {
                    value: 'HTML',
                    label: 'HTML',
                    iconName: 'IconGlobe',
                  },
                  {
                    value: 'CSV',
                    label: 'CSV',
                    iconName: 'IconCodeSquare',
                  },
                  {
                    value: 'Text',
                    label: 'Text',
                    iconName: 'IconFile',
                  },
                  {
                    value: 'Excel95',
                    label: 'Excel 95 +',
                    iconName: 'IconBarChartCircle',
                  },
                  {
                    value: 'Excel2007',
                    label: 'Excel 2007 +',
                    iconName: 'IconBarChartSquare',
                  },
                ]}
              />
            </div>
            <div className="w-full">
              <button
                onClick={() => {
                  if (
                    fileType == 'CSV' ||
                    fileType == 'Text' ||
                    fileType == 'HTML' ||
                    fileType == 'Excel95' ||
                    fileType == 'Excel2007'
                  )
                    setIsConfrim(!isConfrim)
                }}
                className=" bg-bluishGreen text-white min-h-[48px] w-[98%] font-medium rounded-[72px] text-[14px]  "
              >
                Export Data
              </button>
            </div>
          </div>
        )}
      </Modal>
      <Modal
        customStyle={{ borderRadius: 16 }}
        isOpen={isOpenCopy}
        onClose={() => {
          setIsOpenCopy(false)
        }}
      >
        <div
          className={
            'w-[480px] max-h-[80vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={() => {
              setIsOpenCopy(false)
            }}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'copyIcon'}
              stroke={'#02698C'}
              strokeWidth={1}
              height={52}
              width={52}
            />
          </div>
          <div className="flex flex-col gap-5">
            <UICopyLink link={''} />
          </div>
        </div>
      </Modal>

      <Modal
        customStyle={{ width: '480px' }}
        isOpen={isOpenInvite}
        onClose={() => setIsOpenInvite(false)}
      >
        <div
          className={
            'max-h-[80vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={() => setIsOpenInvite(false)}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconAlertTriangle'}
              stroke={'#02698C'}
              strokeWidth={0.5}
              height={56}
              width={56}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-[18px] font-bold'}>
              {'Invite to Incident Report'}
            </h1>
          </div>
          <div className="w-[100%] gap-[15px] justify-between flex mt-[10px]">
            <UiSelect
              onChange={(e) => {
                setUserId(e)
              }}
              // value={formData.status}
              options={userOptions || []}
              title={'user'}
              placeholder={'select user'}
            />
          </div>
          <div className="w-[100%] gap-[15px] justify-between flex mt-[10px]">
            <UiSelect
              disabled
              onChange={(e) => {
                setViewPermissions(e)
              }}
              value={viewPermission}
              options={[
                { label: 'Yes', value: 'Yes' },
                { label: 'No', value: 'No' },
              ]}
              title={'View Permission'}
              placeholder={'select'}
            />
          </div>
          <div className="w-[100%] gap-[15px] justify-between flex mt-[10px]">
            <UiSelect
              onChange={(e) => {
                setEditPermissions(e)
              }}
              value={editPermission}
              options={[
                { label: 'Yes', value: 'Yes' },
                { label: 'No', value: 'No' },
              ]}
              title={'Edit Permission'}
              placeholder={'select'}
            />
          </div>
          <div className="w-[100%] gap-[15px] justify-between flex mt-[10px]">
            <UiSelect
              onChange={(e) => {
                setDeletePermissions(e)
              }}
              value={deletePermission}
              options={[
                { label: 'Yes', value: 'Yes' },
                { label: 'No', value: 'No' },
              ]}
              title={'Delete Permission'}
              placeholder={'select'}
            />
          </div>

          {/* other information */}

          <button
            onClick={() => {
              createNewInnitation()
            }}
            className="bg-bluishGreen text-white min-h-[48px] w-[100%] font-medium rounded-[72px] text-[14px]"
          >
            Invite
          </button>
        </div>
      </Modal>

      <Modal
        customStyle={{ borderRadius: 16, padding: '20px 16px' }}
        isOpen={isOpenCreate}
        onClose={() => {
          setIsOpenCreate(false)
        }}
      >
        <div
          className={
            'w-[480px] max-h-[80vh] min-h-[45vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={() => {
              setIsOpenCreate(false)
            }}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconMessageAlertSquare'}
              stroke={'#02698C'}
              strokeWidth={0.5}
              height={56}
              width={56}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-[18px] font-bold'}>
              Submit a Whistleblowing Report
            </h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Please fill out the following fields
            </p>
          </div>
          <div className="w-full flex-col flex gap-4 mt-3">
            {/* <div>
              <UiSelect
                options={[
                  { value: 'Report1', label: 'Report 1' },
                  { value: 'Report2', label: 'Report 2' },
                ]}
                title={'Report Name'}
              />
            </div> */}
            <div>
              <UITextInput
                iconName={''}
                label="Subject*"
                placeholder="Subject"
                onChange={(e) => {
                  setSubject(e.target.value)
                }}
              />
            </div>
            <div>
              <UITextArea
                label="Description*"
                placeholder="Write description here"
                onChange={(e) => {
                  setDescription(e.target.value)
                }}
              />
            </div>
            <UIRadiobutton
              label={'Report confidentially'}
              checked={isConfidentialSelected}
              onChange={handleConfidentialClick}
              desc="You can choose to report confidentially. Your identity will only
                be known to those who handle your case in confidence, and your
                identity will appear anonymous and confidential to others in
                case processing."
            />
            <UIRadiobutton
              label={'Report anonymously'}
              checked={isAnonymousSelected}
              onChange={handleAnonymousClick}
              desc="You can choose to report anonymously if you prefer not to provide your identity to anyone in the process."
            />
            <WhistleBlowingAboutOfficer
              checked={aboutOfficer}
              onChange={setAboutOfficer}
            />
          </div>
          <div className="w-full mt-4">
            <UIButton
              onClick={() => {
                createWhistle()
              }}
              label="Submit"
            />
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default WhistleblowingLead
